export default __webpack_public_path__ + "static/media/02-doc.eb8f3586.jpg";